import type { ThemeColor } from "@/colors";

export interface DeploymentConfig {
  icon: string;
  color: string;
  themeColor: ThemeColor;
  label: string;
}

export const DEPLOYMENT_CONFIGS = {
  whatsapp: {
    icon: "hugeicons:whatsapp-business",
    color: "#0082fb",
    themeColor: "blue",
    label: "WhatsApp Business",
  },
  whatsapp_baileys: {
    icon: "hugeicons:whatsapp",
    color: "#25D366",
    themeColor: "green",
    label: "WhatsApp Personal",
  },
  chat_widget: {
    icon: "lucide:messages-square",
    color: "#14b8a6",
    themeColor: "teal",
    label: "Chat Widget",
  },
  sip: {
    icon: "lucide:phone",
    color: "#6366f1",
    themeColor: "violet",
    label: "SIP",
  },
  telegram: {
    icon: "hugeicons:telegram",
    color: "#26A5E4",
    themeColor: "sky",
    label: "Telegram",
  },
} as const satisfies Record<string, DeploymentConfig>;

export type DeploymentType = keyof typeof DEPLOYMENT_CONFIGS;
